<template>
    <div>
        <h4 class="cursive">Dettaglio totale</h4>
        <div class="mb-3" v-if="flightFromPartenza && flightToDestinazione">
            <h5 class="mb-0">Volo</h5>
            <div class="d-flex">
                <div>
                    <b class="text-uppercase">{{airportName(flightFromPartenza.partenza.aeroporto.city.objA)}}</b>
                    <span>|</span>
                    <span class="text-uppercase">{{airportName(flightFromPartenza.partenza.aeroporto.airport.objB)}}</span>
                    <span class="mdi mdi-arrow-right mdi-16px"></span>
                    <b class="text-uppercase">{{airportName(flightFromDestinazione.destinazione.aeroporto.city.objA)}}</b>
                    <span>|</span>
                    <span class="text-uppercase">{{airportName(flightFromDestinazione.destinazione.aeroporto.airport.objB)}}</span>
                    <span>({{smallDateFormatter(toDateFromServer(flightFromDestinazione.partenza.dataOra.date.date))}})</span>
                </div>
                <div class="text-center px-2">
                    <span>-</span>
                </div>
                <div>
                    <b class="text-uppercase">{{airportName(flightToPartenza.partenza.aeroporto.city.objA)}}</b>
                    <span>|</span>
                    <span class="text-uppercase">{{airportName(flightToPartenza.partenza.aeroporto.airport.objB)}}</span>
                    <span class="mdi mdi-arrow-right mdi-16px"></span>
                    <b class="text-uppercase">{{airportName(flightToDestinazione.destinazione.aeroporto.city.objA)}}</b>
                    <span>|</span>
                    <span class="text-uppercase">{{airportName(flightToDestinazione.destinazione.aeroporto.airport.objB)}}</span>
                    <span>({{smallDateFormatter(toDateFromServer(flightToDestinazione.destinazione.dataOra.date.date))}})</span>
                </div>
            </div>
            <p v-if="hasArrivalServiceTransfer()"><b>1 notte in transito</b> - andata</p>
        </div>
        <div class="mb-3" v-if="hotels && camere">
            <h5 class="mb-0">Hotel</h5>
            <div>
                <div v-for="(item, index) in hotels" :key="index">
                    <div>
                        <b>{{hotelName(item.hotel.location.name)}}</b>
                        <span>({{middleDateFormatter(item.period.start)}} - {{middleDateFormatter(item.period.end)}})</span>
                    </div>
                    <div>
                        <p v-for="(group, index) in item.groups" :key="index" class="mb-0">Camera {{group.travelGroupId}} ({{cameraText(camere[group.travelGroupId - 1])}}):
                            <b>{{group.rooms.find(room => room.selected).roomInfo.description}}</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-3" v-if="tour && tour.anagrafica">
            <h5 class="mb-0">Tour</h5>
            <div>
                <b>{{hotelName(tour.anagrafica.element.name)}}</b>
                <span>({{tour.anagrafica.element.days}} giorni)</span>
            </div>
        </div>
        <div class="mb-3" v-if="services">
            <h5 class="mb-0">Attività</h5>
            <div>
                <div v-for="(item, index) in services" :key="index">
                    <b>{{item.detail.name}}</b>
                    (<span v-for="(group, index) in item.groups" :key="index" class="px-1">
                        {{smallDateFormatter(group.dateSelected)}}
                    </span>)
                </div>
            </div>
        </div>
        <div class="mb-2" v-if="trasferimenti">
            <h5 class="mb-0">Trasferimenti</h5>
            <div>
                <div v-for="(item, index) in trasferimenti" :key="index">
                    <b>{{item.detail.name}}</b>
                    <span v-if="item.andata"> - andata</span>
                    <span v-if="item.ritorno"> - ritorno</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {airportName, cameraText, hotelName} from '../../../utils/helper'
import {smallDateFormatter, middleDateFormatter, toDateFromServer} from '../../../utils/formatter'

export default {
  name: 'SummaryPreventivo',
  computed: {
    itinerario () {
      return this.getItinerario()
    },
    flightFromPartenza () {
      return this.itinerario.flights.from.voli[0]
    },
    flightFromDestinazione () {
      const length = this.itinerario.flights.from.voli.length
      return this.itinerario.flights.from.voli[length - 1]
    },
    flightToPartenza () {
      const length = this.itinerario.flights.to.voli.length
      return this.itinerario.flights.to.voli[length - 1]
    },
    flightToDestinazione () {
      const length = this.itinerario.flights.to.voli.length
      return this.itinerario.flights.to.voli[length - 1]
    },
    camere () {
      return this.getSearch().camere
    },
    hotels () {
      if (!this.itinerario.hotels.list.length) return null
      return this.itinerario.hotels.list.map(item => item.selected).reduce((t, c) => t.concat(c))
    },
    tour () {
      return this.itinerario.tour
    },
    services () {
      if (!this.itinerario.services.selected.length) return null
      return this.itinerario.services.selected
    },
    trasferimenti () {
      let list = []
      const {andata, ritorno} = this.itinerario.trasferimenti
      if (andata && ritorno && andata.detail.productID === ritorno.detail.productID) {
        list.push({...this.itinerario.trasferimenti.andata, andata: true, ritorno: true})
        return list
      }
      if (this.itinerario.trasferimenti.andata) list.push({...this.itinerario.trasferimenti.andata, andata: true, ritorno: false})
      if (this.itinerario.trasferimenti.ritorno) list.push({...this.itinerario.trasferimenti.ritorno, andata: false, ritorno: true})
      return list.length > 0 ? list : null
    }
  },
  methods: {
    ...mapGetters(['hasArrivalServiceTransfer', 'getSearch', 'getItinerario']),
    cameraText,
    hotelName,
    airportName,
    smallDateFormatter,
    middleDateFormatter,
    toDateFromServer
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/front/components/widgets/common/SummaryPreventivo.vue